var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb',{staticClass:"pl-2 mt-2"}),_c('ProtagonistList',{attrs:{"type":this.$route.name,"posts":_vm.posts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }